import { startOfMonth, endOfMonth, subMonths } from 'date-fns';
import { swedishToday } from './calendarDates';

export interface DatePreset {
  label: string;
  /** Returns start/end or null for custom (manual date pickers). */
  getRange: () => { start: Date; end: Date } | null;
}

/**
 * Build the list of date-range presets used across supplier-stats pages.
 * Labels include the actual year so they stay up to date.
 */
export const getDatePresets = (): DatePreset[] => {
  const now = swedishToday();
  const year = now.getFullYear();
  const prev = year - 1;

  return [
    {
      label: `Vår/Sommar ${prev}`,
      getRange: () => ({
        start: new Date(prev, 0, 1), // Jan 1
        end: new Date(prev, 5, 30), // Jun 30
      }),
    },
    {
      label: `Höst/Vinter ${prev}`,
      getRange: () => ({
        start: new Date(prev, 6, 1), // Jul 1
        end: new Date(prev, 11, 31), // Dec 31
      }),
    },
    {
      label: `Vår/Sommar ${year}`,
      getRange: () => ({
        start: new Date(year, 0, 1),
        end: new Date(year, 5, 30),
      }),
    },
    {
      label: `Höst/Vinter ${year}`,
      getRange: () => ({
        start: new Date(year, 6, 1),
        end: new Date(year, 11, 31),
      }),
    },
    {
      label: 'Denna månad',
      getRange: () => ({
        start: startOfMonth(now),
        end: now,
      }),
    },
    {
      label: 'Förra månaden',
      getRange: () => {
        const prevMonth = subMonths(now, 1);
        return {
          start: startOfMonth(prevMonth),
          end: endOfMonth(prevMonth),
        };
      },
    },
    {
      label: 'Anpassad period',
      getRange: () => null,
    },
  ];
};
